module.exports = __webpack_public_path__ + "static/media/nutricia-brand-allergens-cereals-with-gluten.f42dfc7d.svg";